import React from "react";
import { userSignOut } from "../modules/components/authentication";
import { useNavigate } from 'react-router-dom';
import logger from "../modules/components/logger";

export default function SignOut() {
  const navigate = useNavigate();
  
  React.useEffect(() => {
    userSignOut()
      .then(() => navigate('/'))
      .catch(logger.error);
  });
}